export default __webpack_public_path__ + "static/media/connecting.6be83632.svg";